import { render, staticRenderFns } from "./BlogAuthorIndexPage.vue?vue&type=template&id=31194c45&scoped=true&"
import script from "./BlogAuthorIndexPage.vue?vue&type=script&lang=js&"
export * from "./BlogAuthorIndexPage.vue?vue&type=script&lang=js&"
import style0 from "./BlogAuthorIndexPage.vue?vue&type=style&index=0&id=31194c45&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31194c45",
  null
  
)

export default component.exports